module.exports = __webpack_public_path__ + "img/mail.20e8982e.svg";